import { Moment } from 'moment';
import { PublicKey } from './valueObjects/PublicKey';

export class Certificate {
  constructor(
    private readonly id: number,
    private readonly subject: string,
    private readonly issuer: string,
    private readonly publickey: PublicKey,
    private readonly fingerprint: string | null,
    private readonly expiryDate: Moment | null,
    private readonly digestAlgorithm: string | null
  ) {}

  getId() {
    return this.id;
  }

  getSubject() {
    return this.subject;
  }

  getIssuer() {
    return this.issuer;
  }

  getPublicKey() {
    return this.publickey;
  }

  getFingerprint() {
    return this.fingerprint;
  }

  getExpiryDate() {
    return this.expiryDate;
  }

  getDigestAlgorithm() {
    return this.digestAlgorithm;
  }
}
